/** Drawn icons (24×24), in place of text characters that look different on every device. */
const PATHS = {
  play: 'M7 4l13 8-13 8z',
  list: 'M4 6h16M4 12h16M4 18h10',
  back: 'M15 6l-6 6 6 6',
  next: 'M9 6l6 6-6 6',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z',
  account: 'M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM4 20c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5',
} as const;

export type IconName = keyof typeof PATHS;

/** Filled icons (play, a chosen star) use the text colour as fill; the rest are strokes. */
export function Icon({ name, filled = name === 'play', className }: { name: IconName; filled?: boolean; className?: string }) {
  return (
    <svg className={`icon${className ? ` ${className}` : ''}`} viewBox="0 0 24 24" aria-hidden="true" data-filled={filled}>
      <path d={PATHS[name]} />
    </svg>
  );
}
